import { StateSystemSettings } from "@/store/types";

export const state = (): StateSystemSettings => ({
  mainCurrency: "",
  frontendConfig: null,
  referralProgram: null,
  money: {
    defaultUserPayoutPercent: 0,
  },
  content: null,
  smtp: null,
});
